export default [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view"
  },
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "Edit"
  },
  {
    icon: "el-icon-plus",
    label: "Nueva negociacion",
    command: "new_deal"
  },
  {
    icon: "el-icon-plus",
    label: "Nueva interaccion",
    command: "new_interaction"
  },
  {
    icon: "el-icon-plus",
    label: "Nueva solicitud",
    command: "new_request"
  },
  {
    icon: "el-icon-plus",
    label: "Crear contacto",
    command: "new_contact"
  },
  {
    icon: "el-icon-plus",
    label: "Crear reclamación",
    command: "new_complaint"
  },
  {
    icon: "el-icon-message",
    label: "Enviar encuesta",
    command: "new_survey"
  },
  {
    icon: "el-icon-folder-opened",
    label: "ir a Documentos",
    command: "go_to_documents"
  },
  {
    icon: "el-icon-view",
    label: "Ver Tareas",
    command: "view_task"
  },
  {
    icon: "el-icon-plus",
    label: "Nueva Sollicitud Interna",
    command: "new_internal_request"
  }
];
